import React, { useState, useEffect } from "react";
import { 
    Form, Input, Button, Row, Col, notification, Select, Table,
    Radio, 
} from "antd";
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {
    getTemplateHttpProxy, deleteTemplateHttpProxy, putTemplateHttpProxy
} from "../../../axios/api.device"
import { gaEvent } from "../../../withTracker"

import { useTranslation } from "react-i18next";

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentHttpProxy = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [proxyType, setProxyType] = useState<string>("Auto");
    const [dataForm] = Form.useForm();
    const [pacFallbackAllowed, setPacFallbackAllowed] = useState<boolean>(false);
    const [captiveLoginAllowed, setCaptiveLoginAllowed] = useState<boolean>(false);

    const { t } = useTranslation();

    var addClick = () => { setShowTable(2) }

    useEffect(() => { getDataInfo() }, [])

    const getDataInfo = () => {
        getTemplateHttpProxy(templateId).then((res) => {
            if (res.proxyType) {
                setShowTable(2);
                setProxyType(res.proxyType);
                setPacFallbackAllowed(res.pacFallbackAllowed);
                setCaptiveLoginAllowed(res.captiveLoginAllowed);
                dataForm?.setFieldsValue(res);
            } else {
                setShowTable(1)
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then((res) => {
            console.log(res);
            putTemplateHttpProxy(templateId, res).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                getDataInfo();
            })
        })
    }

    const deleteTemplateClick = () => {
        deleteTemplateHttpProxy(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm.resetFields();
            getDataInfo();
        })
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("全局HTTP代理")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <div style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置全局HTTP代理")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <div style={{ marginLeft: 45 }}>
                        <Form
                            style={{ width: "70%", marginTop: 16 }}
                            layout="vertical"
                            form={dataForm}
                            // labelCol={{ span: 20 }}
                            initialValues={{ proxyType: "Auto",
                                pacFallbackAllowed: pacFallbackAllowed,
                                captiveLoginAllowed: captiveLoginAllowed
                            }}
                        >
                            <Item label={t("Proxy Type")} name="proxyType" rules={[{ required: true }]}>
                                <Select onChange={(key: string) => {
                                    setProxyType(key);
                                    if (key === "Manual") {
                                        dataForm.setFieldsValue({pacUrl: null});
                                    }
                                    else if(key === "Auto")
                                    {
                                        dataForm.setFieldsValue(
                                        {
                                            server: null,
                                            port: null,
                                            userName: null,
                                            password: null,
                                        });
                                    }
                                }}>
                                    <Select.Option value="Auto">{t("Auto")}</Select.Option>
                                    <Select.Option value="Manual">{t("Manual")}</Select.Option>
                                </Select>
                            </Item>

                            <Item 
                                label={t("Proxy PAC URL")} 
                                name="pacUrl" 
                                rules={[{ required: proxyType === "Auto" }]} 
                                hidden={proxyType !== "Auto"}
                                extra={<><InfoCircleOutlined /> {t("URL used to retrieve proxy settings. Must begin with http:// or https://")}</>}
                            >
                                <Input />
                            </Item>

                            <Item 
                                label={t("Proxy Server")} 
                                name="server" 
                                rules={[{ required: proxyType === "Manual" }]} 
                                hidden={proxyType !== "Manual"}
                                extra={<><InfoCircleOutlined /> {t("The proxy server's network address")}</>}
                            >
                                <Input />
                            </Item>

                            <Item 
                                label={t("Proxy Port")} 
                                name="port" 
                                hidden={proxyType !== "Manual"}
                            >
                                <Input />
                            </Item>

                            <Item label={t("Username")} name="userName" hidden={proxyType !== "Manual"}>
                                <Input />
                            </Item>

                            <Item label={t("Password")} name="password" hidden={proxyType !== "Manual"}>
                                <Input.Password />
                            </Item>
                            
                            <Item label={t("Allow direct connection if PAC is unreachable")} name="pacFallbackAllowed" rules={[{ required: true }]}>
                                <Radio.Group >
                                    <Radio value={true}>Allow</Radio>
                                    <Radio value={false}>{t("Block")}</Radio>
                                </Radio.Group>
                            </Item>

                            <Item label={t("Allow bypassing proxy to access captive networks")} name="captiveLoginAllowed" rules={[{ required: true }]}>
                                <Radio.Group >
                                    <Radio value={true}>Allow</Radio>
                                    <Radio value={false}>{t("Block")}</Radio>
                                </Radio.Group>
                            </Item>
                        </Form>

                        <div style={{ margin: "32px 16px 8px 0px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </div>
                )}
            </div>
        </div>

    </>)
};